// extracted by mini-css-extract-plugin
export var container = "dM_g";
export var fadeDiv = "dM_jP";
export var placeholderWrapper = "dM_r1";
export var video = "dM_r2";
export var videoWrapper = "dM_lC";
export var vimeoPlayer = "dM_r3";
export var wrapper = "dM_C";